import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValues5, LocalService, PageKey, Status, TriggeredEvent, Wrapper10Initialization } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { DelivererConfigComponent } from '../../popups/deliverer-config/deliverer-config.component';

@Component({
  selector: 'app-deliverer',
  templateUrl: './deliverer.component.html',
  styleUrls: ['./deliverer.component.scss']
})
export class DelivererComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["deliverer"];
  source: Wrapper10Initialization; maxBodyHeight = 0;
  myDeliverer: KeyValues5; isActive = true; isPrivate = true; isCommitted = false; isShowOnlyPinned = false;
  ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None;
  postalCode: string = '';

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private profileManagementService: ProfileManagementService, private router: Router, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.postalCode = this.localService.loggedMember ? this.localService.loggedMember.loggedMember.localLocations.v5 : '';
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.isShowOnlyPinned = routeParams.isPinnedService == '1';
      this.configurationManagementService.ensurePageActions(this.isShowOnlyPinned ? PageKey.PinnedServices : PageKey.Services);
      this.localService.saveUrl();
      this.localService.setBasicParams(this.localService.getLoginAsCountryCode() , this.userId, this.interactionType);

      this.onLoad();
      if (this.localService.isAddServiveProvider) {
        this.localService.isAddServiveProvider = false;
        this.onClick(1);
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(25);
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.source)
      this.source.locations.selected.v5 = this.postalCode;
    if (!this.source) {
      this.profileManagementService.getDelivererInitialization().subscribe(result => {
        if (result) {
          this.source = result.source;
          this.setMyDeliverer(result.myDeliverer);
        }
      });
    } else {
      if (this.isShowOnlyPinned) {
        this.profileManagementService.getPinnedDeliverers().subscribe(result => {
          this.source.content.items = result;
        });
      } else {
        this.profileManagementService.getDeliverers(this.source.content.paging, this.source.locations.selected).subscribe(result => {
          this.source.content = result;
        });
      }
    }
  }

  onClick(index, value1 = '', value2 = '') {
    switch (index) {
      case 1:
      case 2: {
        const modalRef = this.modalService.open(DelivererConfigComponent);
        if (index == 1)
          modalRef.componentInstance.userId = this.localService.selected.user;
        if (index == 2)
          modalRef.componentInstance.id = this.myDeliverer.key;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.profileManagementService.getMyDeliverer().subscribe(result => {
              this.setMyDeliverer(result);
            });
          }
        });
      } break;
      case 3: {
        this.toggleDeliver(1);
      } break;
      case 4: {
        this.toggleDeliver(2);
      } break;
      case 5: {
        this.toggleDeliver(3);
      } break;
      case 6: {
        this.onOpenBusiness(value1, value2);
      } break;
      case 7: {
        this.router.navigate(['/services' + this.localService.basicParamsString, this.isShowOnlyPinned ? '0' : '1']);
      } break;
    }
  }

  onOpenBusiness(key: string, ctryCode: string) {
    if (key == '') {
      this.localService.showMessage(this.localService.languageContent.deliverer.biz_not_linked);
    } else {
      if (ctryCode == this.localService.selected.countryCode)
        this.router.navigate(['/billing' + this.localService.basicParamsString, key, 0]);
      else
        this.localService.showMessage(this.localService.languageContent.deliverer.need_same_ctry);
    }
  }

  toggleDeliver(index) {
    this.profileManagementService.toggleDeliver(this.myDeliverer.key, index).subscribe(result => {
      this.setMyDeliverer(result);
    });
  }

  setMyDeliverer(result: KeyValues5) {
    this.myDeliverer = result;
    this.isActive = this.myDeliverer.v1 == '1';
    this.isPrivate = this.myDeliverer.v2 == '1';
    this.isCommitted = this.myDeliverer.v3 == '0';
  }

  onSavePinnedItem(strId, isUnpin) {
    this.profileManagementService.savePinnedDeliverers(strId, isUnpin).subscribe(result => {
      switch (result) {
        case Status.Success: {
          this.source.content.items.find(x => x.key == strId).v8 = isUnpin ? "0" : "1";
        } break;
      }
    });
  }
}
